<template>
  <div
    ref="wrapper"
    :id="id"
    class="inline-audio"
    :data-progress="progress"
    >
    <audio
      ref="audio"
      preload="metadata"
      :src="audioUrl"
      v-on:loadeddata="onLoad"
      v-on:loadedmetadata="onLoadedMetaData"
      v-on:timeupdate="onUpdateProgress"
      v-on:playing="onPlaying"
      >
      Your device does not support audio playback
    </audio>
    <div class="inline-audio__controls">
      <button
        ref="button"
        class="
          inline-audio__button
        "
        :aria-label="playing ? 'Pause' : 'Play'"
        @click.prevent="onClickPlayPause"
        >
        <div class="inline-audio__progress">
          <div
            ref="progress-base"
            class="
              inline-audio__progress__base
            "
            @animationiteration="onFinishedLoadAnimation"
          />
          <div class="inline-audio__progress__mask--left">
            <div class="inline-audio__progress__elapsed--left" />
          </div>
          <div class="inline-audio__progress__mask--right">
            <div class="inline-audio__progress__elapsed--right" />
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          class="inline-audio__button__svg--play">
          <path
            d="M17.5 12.064L7 6v12.13z"
            fill-rule="evenodd"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          class="inline-audio__button__svg--pause">
          <path
            d="M14 6h4v12h-4V6zM6 6h4v12H6V6z"
            fill-rule="evenodd"
          />
        </svg>
      </button>
    </div>
    <div class="inline-audio__caption">
      <span
        class="inline-audio__title__text"
        v-html="audioTitle"
      />
      <span
        ref="duration"
        class="inline-audio__duration__text"
        v-html="duration"
      />
    </div>
  </div>
</template>

<script>
import AnalyticsMixin from '../shared/audio-analytics-mixin';

export default {
  mixins: [ AnalyticsMixin ],
  props: {
    id:         {type: String, required: true},
    audioId:    {type: String, required: true},
    audioUrl:   {type: String, required: true},
    audioTitle: {type: String, required: true},
  },
  data () {
    return {
      loaded: false,
      playing: false,
      progress: 0,
      duration: '',
    }
  },
  mounted() {
    document.addEventListener("playingAudio", this._audioIsBeingPlayed);
  },
  methods: {
    _audioIsBeingPlayed: function(e) {
      if (e.detail != this.$refs.audio && !this.$refs.audio.paused) {
        this.onClickPlayPause.bind(this)();
      }
    },
    onClickPlayPause: function() {
      if (this.$refs.audio.paused) {
        this.$refs.wrapper.classList.add("inline-audio--loading");
        this.$refs.audio.play();
        this.playing = true;

        const propagatePlayingEvent = new CustomEvent('playingAudio', { detail: this.$refs.audio });
        document.dispatchEvent(propagatePlayingEvent);
      } else {
        this.$refs.audio.pause();
        this.$refs.wrapper.classList.remove("inline-audio--playing");
        this.playing = false;
      }
    },
    onFinishedLoadAnimation: function() {
      this.$refs.wrapper.classList.remove("inline-audio--loading");
    },
		onLoad() {
			if (this.$refs.audio.readyState >= 2) {
				this.loaded = true;
			} else {
			  throw new Error('Failed to load sound file.');
      }
		},
    onLoadedMetaData: function() {
      const duration = this.$refs.audio.duration;
      const minutes =  Math.ceil(duration / 60);
      const minutesText = (minutes == 1) ? "minute" : "minutes";
      this.$refs.duration.classList.add("inline-audio__duration__text--loaded");
      this.duration = `${minutes} ${minutesText}`;
    },
		onPlaying() {
      this.$refs.wrapper.classList.add("inline-audio--playing");
		},
    onUpdateProgress: function() {
      this.progress = Math.floor(offset);

      const offset = this.$refs.audio.currentTime / this.$refs.audio.duration * 100;
      this.$_pushAudioPlaybackEvent(this.audioId, offset);
    },
  },
  beforeDestroy() {
    document.removeEventListener("playingAudio", this._audioIsBeingPlayed);
  },
}
</script>
